module.exports = __webpack_public_path__ + "0ab42abec42ac0bad432e62cfed394ce.mp3";